import { RouteObject } from "react-router-dom";
import RequireAuth from "../../auth/requireAuth";
import { CommunityContainer } from "../community/communityContainer";
import { permissions, roles } from "../../assets/configuration/claimSettings";
import { CategoryContainer } from "./resource/category/categoryContainer";

export const CommunityRoutes: RouteObject = {
  path: "community",
  children: [
    {
      path: "communityresourcecategories",
      element: (
        <RequireAuth
          requiredPermission={[
            permissions.SystemFull,
            permissions.ManageCommunity,
          ]}
        >
          <CategoryContainer />
        </RequireAuth>
      ),
    },
  ],
};
